import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class DxScript {
  name = ""
  body = ""
}

export const DX_SCRIPT_DESER: SchemaDeSer<DxScript> = new SchemaDeSerBuilder(
  DxScript
)
  .ofStrings("name", "body")
  .toDeSer()
